jQuery('.time-block-row button').click(function(){
	
	jQuery( this ).parent().parent().addClass('selected-time-block');
	
	var consultant = jQuery( '.consultant-banner' ).data( 'consultant' );
	var month = jQuery( this ).parent().parent().data( 'month' );
	var day = jQuery( this ).parent().parent().data( 'day' ); 
	var year = jQuery( this ).parent().parent().data( 'year' );
	
	var timezone = jQuery( '.button.reschedule' ).data( 'timezone' );
	
	var student = jQuery( this ).parent().parent().data( 'student' );
	
	var block = jQuery( this ).parent().parent().data( 'block' );
	var action = jQuery( this ).attr( 'class' );
	
	if( action == 'reschedule' ) {
		
		print_consultant_calendar( consultant, month, day, year, timezone );
		jQuery('.time-block-row').hide();
		jQuery('.reschedule-appointment').show();
	}
	
	else {
		//new_block, month, day, year, time, student
		update_appointment( block, action, '', month, day, year, '', student );
	}	
	
	
});

jQuery('.reschedule.button').click(function(){
	
	//var consultant = jQuery( '.consultant-banner' ).data( 'consultant' );
	
	var block = jQuery('.selected-time-block').data('block');
	
	//var action = jQuery( this ).attr( 'class' );
	
	var new_block = jQuery('.reschedule-to').data('id');
	
	var month = jQuery('.consultant-calendar').data('month');
	
	var day = jQuery('.consultant-calendar').data('day');
	
	var year = jQuery('.consultant-calendar').data('year');
	
	var time = jQuery('.reschedule-to').data('time');
	
	var student = jQuery('.selected-time-block').data('student');
	
	if( time == '' ) {
		alert('select a time block');
	}
	
	else {
		
		update_appointment( block, 'reschedule', new_block, month, day, year, time, student );

	}
	

});

jQuery('.past.day-number').click(function(e){

	e.preventDefault();
	
});